import React from "react";

// Hook
import { useAuth } from "../hooks/useAuth";

// Component
import MainView from "../components/MainView";

// Helper
import { toRankString } from "../helpers/appHelper";
import ProgressChart from "../components/progressChart";

export default function ProfileStats() {
  const graphCtnRef = React.useRef(null);
  const [graphSize, setGraphSize] = React.useState({ width: 0, height: 0 });

  const { auth } = useAuth();
  const { user } = auth;

  const rank = 1;
  const score = 100;
  const data = [
    { name: "Mon", value: 120 },
    { name: "Tue", value: 40 },
    { name: "Wed", value: 80 },
    { name: "Thu", value: 0 },
    { name: "Fri", value: 100 },
    { name: "Sat", value: 60 },
    { name: "Sun", value: 80 },
  ];

  React.useEffect(() => {
    const graphCtn = graphCtnRef.current;
    
    let { width, height } = graphCtn.getBoundingClientRect();
    width = Math.floor(width);
    height = Math.floor(height);

    setGraphSize({ width, height });

    window.addEventListener("resize", () => {
      let { width, height } = graphCtn.getBoundingClientRect();
      width = Math.floor(width);
      height = Math.floor(height);

      setGraphSize({ width, height });
    });
  }, []);

  return (
    <MainView>
      <div className="py-5 last:pt-0 sm:pb-9 px-[5vw] 2xl:px-[15vw]">
        <div className="lg:max-w-5xl mx-auto flex flex-wrap md:flex-nowrap justify-center gap-5 sm:gap-9">
          <div className="retro-border-gold w-[45%] md:w-[32%] h-40 lg:h-72 flex flex-col items-center justify-center">
            <p className="font-bold font-retro-rounded text-base sm:text-xl capitalize">
              Session Count
            </p>

            <p className="font-bold font-retro-rounded text-5xl sm:text-6xl">
              {user.session}
            </p>
          </div>

          <div className="retro-border-gold w-[45%] md:w-[32%] h-40 lg:h-72 flex flex-col items-center justify-center">
            <p className="font-bold font-retro-rounded text-base sm:text-xl capitalize">
              Ranking
            </p>

            <p className="font-bold font-retro-rounded text-5xl sm:text-6xl">
              {toRankString(rank)}
            </p>
          </div>

          <div className="retro-border-gold w-[45%] md:w-[32%] h-40 lg:h-72 flex flex-col items-center justify-center">
            <p className="font-bold font-retro-rounded text-5xl sm:text-6xl">
              {score}
            </p>
          </div>
        </div>
      </div>

      <div className="py-5 last:pt-0 sm:pb-9 px-[5vw] 2xl:px-[15vw]">
        <div className="w-full lg:max-w-4xl mx-auto">
          <p className="mr-auto pb-5 font-bold font-retro-rounded text-xl sm:text-3xl">
            Progress Graph
          </p>
          <div ref={graphCtnRef} className="w-full h-52 sm:h-96">
            <ProgressChart
              data={data}
              width={graphSize.width}
              height={graphSize.height}
            />
          </div>
        </div>
      </div>
    </MainView>
  );
}
